import * as React from "react";
import { ITasks } from "./types";

export const TasksContext = React.createContext<ITasks>({
  mnpPortout: undefined,
});

export function useTasks() {
  const value = React.useContext(TasksContext);

  if (value === null) {
    throw new Error("`Missing tasksContext` in tree.");
  }

  return value;
}
